import { VideoCallAction, AgoraClientEventAction, AgoraStreamEventAction } from 'components/features/videoCalls/types/actions'
import { Observable } from 'rxjs'
import { byType } from 'rxOperators/byType'
import { map, filter } from 'rxjs/operators'
import { AgoraClientEventType, StreamId, AgoraStreamEventType } from 'components/features/videoCalls/types/agoraTypes'

export type DevicePermissions = 'denied' | 'granted' | 'prompt' | 'cantTest'
export const getDevicePermissions = async (name: DevicePermissionDescriptor['name']): Promise<DevicePermissions> => {
  try {
    return (await navigator.permissions.query({ name })).state
  } catch (e) {}

  return 'cantTest' as const
}

export const getPermissions = async () => {
  const [cameraPermissions, microphonePermissions] = await Promise.all([
    getDevicePermissions('camera'),
    getDevicePermissions('microphone'),
  ])

  return {
    cameraPermissions,
    microphonePermissions,
  }
}

export const isScreenShare = (streamId: StreamId) => {
  return streamId < 10_000_000
}

export const filterAgoraClientEvent = <T extends AgoraClientEventType['type']>(eventType: T) => (subject: Observable<VideoCallAction>): Observable<Extract<AgoraClientEventType, { type: T }>> => subject.pipe(
  byType(AgoraClientEventAction.type),
  map((action) => action.payload),
  filter((event): event is Extract<AgoraClientEventType, { type: T }> => event.type === eventType)
)

export const filterAgoraStreamEvent = <T extends AgoraStreamEventType['type']>(eventType: T) => (subject: Observable<VideoCallAction>): Observable<Extract<AgoraStreamEventType, { type: T }>> => subject.pipe(
  byType(AgoraStreamEventAction.type),
  map((action) => action.payload),
  filter((event): event is Extract<AgoraStreamEventType, { type: T }> => event.type === eventType)
)
